import { useEffect, useRef, useState, useCallback } from "react";
import { useWidgetInnerSize } from "./useWidgetInnerSize.js";

export const useDatatable = ({ tablePlaceholder, widgetId, tableRef, widgetRef, theme }) => {
  const {height} = useWidgetInnerSize(widgetRef, theme);
  const [pageCount, setPageCount] = useState(10);
  const timeoutRef = useRef(null);

  const saveState = (settings, data) => {
    delete data.columns;
  };

  const calculateSize = useCallback(() => {
    const tableEl = tablePlaceholder.current;
    if (!tableEl) return;

    const cell = tableEl.querySelector("td");
    const heightCell = cell?.offsetHeight || 0;
    if (!heightCell) return;

    let count = Math.floor((height - 80) / heightCell);
    if (count < 1) count = 1;

    setPageCount(prev => {
      if (prev !== count) {
        tableRef.current?.page.len(count);
        tableRef.current?.draw(false);
        return count;
      }
      return prev;
    });
  }, [tablePlaceholder, widgetId, tableRef, height]);

  const resize = useCallback(() => {
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(calculateSize, 200);
  }, [calculateSize]);

  useEffect(() => {
    if (!tablePlaceholder.current || !height) return;
    resize();
  }, [height, tableRef.current]);

  return {
    pageCount,
    saveState
  };
};
